<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
      filteringTag: null,
      activeAdvancedFilters: [],
      activeItem: '',
    }
  },
  mounted() {
    const urlParams = new URLSearchParams(window.location.search);
    const filter = urlParams.get('filter');
    const item = this.content.main_filters.find(el => el.filter == filter);
    this.toggleFilter(item);
  },
  computed: {
    resultContent() {
      return globalState.pageModel.name_to_content[this.content.filters_content];
    }
  },
  methods: {
    toggleFiltersModal() {
      $(`#${this.content.name}-filters-modal`).modal('toggle');
    },
    resetAdvancedFilters() {
      Vue.set(this, 'activeAdvancedFilters', []);
      this.getContents();
    },
    applyAdvancedFilters() {
      this.getContents();
      $(`#${this.content.name}-filters-modal`).modal('hide');
    },
    toggleFilter(item) {
      if (Fandom.exists(item)) {
        this.activeItem = this.getContent(item.filter).title;
        this.filteringTag = item.filter;
      } else {
        this.activeItem = this.ft("globals.all");
        this.filteringTag = null;
      }
      this.getContents(false);
    },
    getContents() {
      const params = this.filtersToGetContentsParams();
      Fandom.getContents(this.content.filters_content, params, () => {}, false);
    },
    alternativeAppendContents(_, successBlock) {
      const params = this.filtersToGetContentsParams(true);
      Fandom.appendContents(this.content.filters_content, successBlock, this.content.limit, params)
    },
    filtersToGetContentsParams() {
      const params = {
        include_rich_info: false,
        content_filtering: []
      };

      if (this.content.limit) {
        params.limit = this.content.limit;
      }

      if (Fandom.exists(this.filteringTag)) {
        params.content_filtering.push([this.filteringTag]);
      }

      // advanced filtering management: if there is a filteringTag, it is in AND with all (activeAdvancedFilters in OR)
      if (this.activeAdvancedFilters.length > 0) {
        params.content_filtering.push(this.activeAdvancedFilters);
      }
      return params;
    }
  }
};

</script>

<template>
  <div 
    v-easyadmin="easyadminId" 
    :class="contentType" 
    class="container-fluid p-0" 
    v-if="isContentVisibleToUser()" 
    filters-component
  >
    <!-- filter navbar mobile -->
    <nav class="navbar navbar-expand-md navbar-light d-md-none mx-3 border bg-white p-0">
      <a data-toggle="collapse" class="collapsed d-flex align-items-center justify-content-between w-100" href="#collapsibleNavbar">
        <span class="navbar-brand mx-3 text-uppercase" href="#">{{activeItem}}</span>
        <div class="navbar-toggler mx-3 px-0 d-flex align-items-center">
          <i class="fal fa-chevron-up"></i>
        </div>
      </a>
      <div class="collapse navbar-collapse" id="collapsibleNavbar">
        <div class="py-2 px-3 border-top">
          <ul class="navbar-nav">
            <li class="nav-item" :class="{'d-none': activeItem == ft('globals.all')}" v-if="content.filters_content">
              <a 
                class="nav-link text-uppercase" 
                href="javascript:void(0)" 
                @click="toggleFilter()" 
                :class="{'active': activeItem == ft('globals.all')}"
              >{{ft("globals.all")}}</a>
            </li>
            <li class="nav-item" :class="{'d-none': filter.filter == filteringTag}" v-for="filter in content.main_filters" :key="`filter-${filter.filter}`">
              <a 
                class="nav-link text-uppercase" 
                href="javascript:void(0)" 
                @click="toggleFilter(filter)" 
                :class="{'active': filter.filter == filteringTag}"
              >{{getContent(filter.filter).title}}</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <!-- filter buttons for desktop -->
    <div class="container-fluid" v-if="content.main_filters || content.advanced_filters"> 
      <div class="row justify-content-center">
        <div class="col-12 d-none d-md-flex justify-content-center flex-wrap align-items-center">
          <h3 class="mx-5">{{ft("globals.filter_contents")}}</h3>
          <div class="btn-group flex-wrap mb-4" role="group" v-if="content.main_filters && content.main_filters.length > 0">
            <button 
              v-if="content.filters_content" 
              class="btn btn-outline-dark shadow-none btn-squared" 
              @click="toggleFilter()" 
              :class="{'active': activeItem == ft('globals.all')}"
            >
              {{ft("globals.all")}}
            </button>
            <button 
              v-for="(filter, index) in content.main_filters"
              class="btn shadow-none btn-outline-dark btn-squared" 
              @click="toggleFilter(filter)" 
              :class="{'active': filter.filter == filteringTag}"
              :key="`filter-${index}`"
            >
              {{getContent(filter.filter).title}}
            </button>
          </div>
          <button class="btn btn-outline-dark mx-5 mb-4 px-4" v-if="content.advanced_filters" @click="toggleFiltersModal()">
            {{ft('globals.more_filters')}} <i class="fal fa-plus ml-2"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="container-fluid my-4 d-md-none" v-if="content.advanced_filters && content.advanced_filters.length > 0"> 
      <div class="row justify-content-center">
        <div class="col-12">
          <button class="btn btn-outline-dark w-100 px-4" @click="toggleFiltersModal()">
            {{ft('globals.more_filters')}} <i class="fal fa-plus ml-2"></i>
          </button>
        </div>
      </div>
    </div>
    <template v-if="resultContent">
      <component 
        :is="'grid-fixed'" 
        :ref="`grid-fixed-${this.resultContent.name}`" 
        :content="resultContent" 
        :key="resultContent.name" 
        :alternative-append-contents="alternativeAppendContents"
      ></component>
    </template>
    <div class="modal fade align-items-center justify-content-center" ref="filters-modal" :id="`${content.name}-filters-modal`" v-if="content.advanced_filters && content.advanced_filters.length > 0">
      <div class="modal-dialog filters-modal modal-lg">
        <div class="modal-content">
          <div class="modal-header border-bottom-0">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <i class="fal fa-times"></i>
            </button>
          </div>
          <div class="modal-body container pb-sm-3 pb-md-4">
            <h3 class="h1 text-center">{{ft("globals.choose_your_filters")}}</h3>
            <div class="filters-container px-3 px-md-4 my-4 my-md-5">
              <div v-for="(filter, index) in content.advanced_filters" :key="index">
                <h4 class="font-weight-normal text-uppercase subfilters-title" :class="{'mt-4 pt-md-2': index > 0}">{{filter.title}}</h4>
                <div class="subfilters-container mx-n1">
                  <button
                    class="btn btn-outline-dark shadow-none btn-squared mx-1 btn-sm px-3 py-2"
                    v-for="(subfilter, subindex) in filter.filters"
                    :class="{'active': activeAdvancedFilters.indexOf(subfilter) > -1}"
                    :key="`subfilter-${index}-${subindex}`"
                    @click="() => {activeAdvancedFilters.push(subfilter)}"
                    >
                    {{getContent(subfilter).title}}
                  </button>
                </div>
              </div>
            </div>
            <div class="w-100 d-flex justify-content-center py-3">
              <button class="btn px-4 mr-2 btn-dark" @click="applyAdvancedFilters()">{{ft("globals.apply_selection")}}</button>
              <button class="btn btn-outline-dark px-4" @click="resetAdvancedFilters()">{{ft("globals.reset_filters")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[filters-component] {
  .navbar {
    background-color: $gray-200;
  }

  .navbar-brand {
    font-size: 1rem;
    font-weight: 600;
  }

  [isotope-grid] {
    padding-top: 0!important;
  }

  #svg-triangle {
    fill: #F4F2F3;
    width: 5rem;  
    enable-background: new 0 0 128 53;
  }

  .label {
    font-size: $font-size-xs;
    color: $gray-700;
    text-transform: uppercase;
    width: 6.25rem;
  }

  .triangle {
    background-color: $white;
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 100%;
    transition: all .25s;
    border: 1px solid $gray-400;
    outline: 0px transparent;

    .fa-caret-down {
      color: $gray-700;
    }

    &:disabled {
      border-color: $gray-300;
      cursor: not-allowed;

      .fa-caret-down {
        color: $gray-300;
      }
    }

    &:hover:not(:disabled) {
      background-color: $gray-400;
      .fa-caret-down {
        color: $white;
      }
    }

    &:not(.collapsed) {
      transform: rotate(180deg);
      background-color: $dark;
      border-color: transparent;

      .fa-caret-down {
        color: $white;
      }
    }
  }

  .navbar-toggler {
    font-size: .875rem;
    transition: transform .25s;
    height: 4rem;
    border: none;

    &:focus {
      outline: 0px;
    }
  }

  .collapsed .navbar-toggler {
    transform: rotate(180deg);
  }

  .btn-squared {
    border-radius: 0px;
  }

  .modal-content {
    border-radius: 0;
  }

  .filters-modal {

    .h1 {
      font-weight: 900;
    }

    .subfilters-title {
      font-size: .8125rem;
    }

    .subfilters-container {
      .btn-sm {
        font-size: .75rem;
      }
    }
  }

}
</style>